import moment from 'moment'
import 'moment/locale/pt-br'
import { useMemo, useRef } from 'react'

import withRootContext from 'src/context/withRootContextHOC'
import { useDateTimeContext } from 'src/context/dateTimeContext'
import { useServiceScheduleContext } from 'src/context/serviceScheduleContext'

import SchedulingInfo from '../schedulingInfo'
import Calendar from 'src/components/calendar'
import FormSteps from 'src/components/formSteps'
import PageContainer from 'src/components/pageContainer'
import Tag from 'src/components/tag'

import { scheduleCalendarNavigation, mapMonthByDate } from 'src/utils'
import { assetPrefix } from 'src/config/env_config'

import * as S from './styles'
import * as Gs from 'src/styles/global'

const TimeStep = (props) => {
  const { context } = props
  const timeRef = useRef()
  const { state: schedulingState } = useServiceScheduleContext()
  const { functions } = useDateTimeContext()

  const {
    campaigns,
    timeData,
    times,
    scheduleBody,
    availableDates,
    calendarYear,
    calendarMonth,
    partnersData,
    productCoupon
  } = schedulingState

  const {
    handleSelectDay,
    handleSelectTime,
    handleCalendarNavigation
  } = functions

  const morningTimes = times?.filter(time => moment(time, 'HH:mm').isSameOrBefore(moment('12:00', 'HH:mm')))
  const afternoonTimes = times?.filter(time => moment(time, 'HH:mm').isAfter(moment('12:00', 'HH:mm')))
  const calendarDate = moment([
    calendarYear,
    calendarMonth - 1,
    1
  ]).toDate()

  const month = mapMonthByDate(calendarDate)
  const disabledDays = useMemo(() => mapMonthByDate(calendarDate).filter(day => !availableDates.includes(day.getDate())), [availableDates, calendarDate])
  const monthHasCampaign = !!campaigns?.length
  const monthHasCoupon = productCoupon && moment(productCoupon?.start).month() === calendarMonth - 1
  const shouldHideCampaignCaption = !monthHasCampaign && !monthHasCoupon
  const campaignDays = useMemo(() => month.filter(day => {
    const currentDate = moment(day)
    const campaignDay = campaigns?.some(campaign => {
      const startDate = moment(campaign.start)
      const endDate = moment(campaign.end)
      return currentDate.isBetween(startDate, endDate, 'day', '[]')
    })

    const couponStart = moment(productCoupon?.start)
    const couponEnd = moment(productCoupon?.end)
    const couponDay = !!productCoupon && currentDate.isBetween(couponStart, couponEnd, 'day', '[]')
    return campaignDay || couponDay
  }, [month, campaigns, productCoupon]))

  const selectedPartner = partnersData.find(
    ({ id }) => id === scheduleBody.partner_id
  )

  const navigationCallback = (operation, view) => scheduleCalendarNavigation(operation, view, calendarYear, calendarMonth, handleCalendarNavigation, { context })

  return (
    <PageContainer isSchedulingSteps>
      <FormSteps context={context}>
        <S.PageContainer>
          <Gs.WrapperFormAndCard>
            <S.AlignWrappers>
              <S.WrapperTitle>
                <span>Selecione a data</span>
              </S.WrapperTitle>
              <S.CalendarWrapper>
                <Calendar
                  disabledDays={disabledDays}
                  campaignDays={campaignDays}
                  availableDates={availableDates}
                  onChangeDay={(date) => handleSelectDay(date, timeRef, { context })}
                  displayDate={calendarDate}
                  initialValue={scheduleBody.selectDay}
                  onChangeCalendar={navigationCallback}
                  showOutsideDays
                />
                {(!shouldHideCampaignCaption) && (
                  <S.CaptionsWrapper>
                    <S.CaptionsTitle>Legenda:</S.CaptionsTitle>
                    <S.Captions>
                      <S.CaptionItem>
                        <S.Color
                          color='var(--pale-sky-blue)'
                        />
                        <S.Caption>Período promocional*</S.Caption>
                      </S.CaptionItem>
                      <S.Caption>* Dias marcados significam benefícios exclusivos dentro do período promocional.</S.Caption>
                    </S.Captions>
                  </S.CaptionsWrapper>
                )}
                <S.InfoCard>
                  <img src={`${assetPrefix}/static/icons/info-icon.svg`} />
                  <aside>
                    Caso o dia e horário que procura não estiver disponível, você pode ligar para {selectedPartner?.phone ?? 'a loja'} e solicitar um encaixe.
                  </aside>
                </S.InfoCard>
              </S.CalendarWrapper>
              {scheduleBody.selectDay && (
                <div>
                  <S.WrapperTitle ref={timeRef} noPaddingTop>
                    Selecione o horário
                  </S.WrapperTitle>
                  <S.TimeContent>
                    <S.Period>
                      <h3>
                        Manhã
                      </h3>
                      <S.WrapperTags>
                        {
                          morningTimes.map(time => {
                            const isDisabled = !timeData || !timeData.includes(time)
                            return (
                              <Tag
                                key={'time-' + time}
                                onClick={() => handleSelectTime(time, { context })}
                                disabled={isDisabled}
                                selected={time === scheduleBody.selectTime}
                              >
                                {time}
                              </Tag>
                            )
                          })
                        }
                      </S.WrapperTags>
                    </S.Period>
                    <hr />
                    <S.Period>
                      <h3>
                        Tarde
                      </h3>
                      <S.WrapperTags>
                        {
                          afternoonTimes.map(time => {
                            const isDisabled = !timeData || !timeData.includes(time)
                            return (
                              <Tag
                                key={'time-' + time}
                                onClick={() => handleSelectTime(time, { context })}
                                disabled={isDisabled}
                                selected={time === scheduleBody.selectTime}
                              >
                                {time}
                              </Tag>
                            )
                          })
                        }
                      </S.WrapperTags>
                    </S.Period>
                  </S.TimeContent>
                </div>)}
            </S.AlignWrappers>
            <SchedulingInfo />
          </Gs.WrapperFormAndCard>
        </S.PageContainer>
      </FormSteps>
    </PageContainer>
  )
}

export default withRootContext(TimeStep)
